import xml2json from './xml2json';
import string2xml from './string2xml'; //@ts-check
//Utilities for working with Contact entities

var ENGAGEMENT_PROP = '_system_Engagement';
export var getPropVal = function getPropVal(obj, propName) {
  if (!obj) return '';

  if (typeof obj[propName] !== 'undefined') {
    return obj[propName];
  }

  if (!obj.Properties) return '';

  for (var pIdx = 0; pIdx < obj.Properties.length; pIdx++) {
    if (obj.Properties[pIdx].Name === propName) return obj.Properties[pIdx].Value;
  }

  return '';
};

var getDisplayName = function getDisplayName(data) {
  if (!data) return '';
  var lastName = getPropVal(data, 'Last_Name');
  var firstName = getPropVal(data, 'First_Name');
  if (firstName && lastName) return lastName + ', ' + firstName;
  if (firstName) return firstName;
  if (lastName) return lastName;
  return '';
};

var isLead = function isLead(data) {
  return getPropVal(data, '_system_CRM_Type') === 'Lead';
};

var getType = function getType(data) {
  return isLead(data) ? 'Lead' : 'Contact';
};

var getPropEngagement = function getPropEngagement(data) {
  var engagementProp = getPropVal(data, ENGAGEMENT_PROP);
  if (!engagementProp) return null;
  var eng = xml2json(string2xml(engagementProp));
  if (!eng['contact-engagement-property']) return null;
  eng = eng['contact-engagement-property'];
  var PersonaId = null;
  if (eng['persona']) PersonaId = parseInt(eng['persona']['@attributes']['persona-id'], 10);
  var Threads = [];
  if (eng['journey-threads']['journey-thread']) Threads = eng['journey-threads']['journey-thread'].map(function (t) {
    return {
      JourneyId: parseInt(t['@attributes']['journey-id'], 10),
      JourneyType: t['@attributes']['journey-type'],
      StageId: parseInt(t['@attributes']['stage-id'], 10),
      TouchpointId: parseInt(t['@attributes']['touchpoint-id'], 10),
      ThreadId: t['@attributes']['thread-id'],
      ContactId: data.Id
    };
  });
  return {
    PersonaId: PersonaId,
    Threads: Threads
  };
};

function memoize(fn) {
  var memo = new WeakMap();
  return function () {
    var arg = arguments[0];
    if (memo.has(arg)) return memo.get(arg);else {
      var result = fn(arg);
      memo.set(arg, result);
      return result;
    }
  };
}

export default {
  getPropVal: getPropVal,
  getPropEngagement: memoize(getPropEngagement),
  getDisplayName: getDisplayName,
  isLead: isLead,
  getType: getType
};